import { useForm } from "react-hook-form";
import { AddIcon, DeleteIcon, EditIcon, HamburgerIcon } from '@chakra-ui/icons'
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Badge,
   Button, FormControl, FormLabel, IconButton, Input, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody,
    ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Switch, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDoorData } from '../context/DoorContext'

function DoorAdminPage() {

  const { user, loading, axiosJWT, allDoors, getAllDoors } = useDoorData()
  const toast = useToast()
  const navigate = useNavigate()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenAlert, onOpen: onOpenAlert, onClose: onCloseAlert } = useDisclosure()
  const cancelRef = React.useRef()
  const { register, setValue, handleSubmit, formState: { isSubmitting }, reset } = useForm();
  const [editMode, setEditMode] = useState(false);
  const [editDoor, setEditDoor] = useState([]);
  const [deleteDoor, setDeleteDoor] = useState([]);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user])

  useEffect(() => {
    getAllDoors()

  }, [])

    useEffect(() => {
  if (!editDoor) return;

  setValue("DoorName", editDoor.DoorName);

  // normalizuojam DoorSerial
  const serial =
    editDoor.DoorSerial === null ||
    editDoor.DoorSerial === "null" ||
    editDoor.DoorSerial === ""
      ? ""
      : editDoor.DoorSerial;

  setValue("DoorSerial", serial);

  setValue("IsMainDoor", editDoor.isMainDoor === 1);
}, [editDoor, setValue]);

  const onSubmit = async data => {
      try {
        const res = await axiosJWT.put("/api/doors/create", { DoorName: data.DoorName, DoorSerial: data.DoorSerial, IsMainDoor: data.IsMainDoor ? 1 : 0 })
        if (res) {
          toast({
            title: '👋 Durys sukurtos!',
            position: 'bottom',
            status: 'success',
            isClosable: true,
            duration: 4000
          })
          getAllDoors();
          onClose();
          reset();

        }

      } catch (err) {
        console.log(err.response.data);
        toast({
          title: err.response.data,
          position: 'bottom',
          status: 'error',
          isClosable: true,
          duration: 4000
        })
      
    }

  };

  const onEdit = async data => {
      try {
        console.log("data------>");
        console.log(data);
        const res = await axiosJWT.put("/api/doors/edit", { DoorID: editDoor.DoorID, DoorName: data.DoorName, DoorSerial: data.DoorSerial, IsMainDoor: data.IsMainDoor ? 1 : 0})
        if (res) {
          toast({
            title: '👋 Durys redaguotos!',
            position: 'bottom',
            status: 'success',
            isClosable: true,
            duration: 4000
          })
          getAllDoors();
          onClose();
          setEditDoor([])
          reset();

        }

      } catch (err) {
        console.log(err.response.data);
        toast({
          title: err.response.data,
          position: 'bottom',
          status: 'error',
          isClosable: true,
          duration: 4000
        })
        onClose();
        setEditDoor([])
      
    }



  };

  const handleDelete = async (userID) => {
    try {
      const res = await axiosJWT.delete(`/api/doors/delete/${userID}`)
      if (res) {
        toast({
          title: '👋 Durys ištrintos!',
          position: 'bottom',
          status: 'success',
          isClosable: true,
          duration: 4000
        })
        getAllDoors();
        setDeleteDoor([]);
        onCloseAlert();

      }

    } catch (err) {
      console.log(err.response.data);
      toast({
        title: err.response.data,
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
    }
  }



  return (
    <>
      <Button maxW={'12rem'} mx={'1rem'} leftIcon={<AddIcon />} onClick={() => { reset(); setEditDoor([]); setEditMode(false); onOpen(); }} colorScheme={'blue'}>Sukurti duris</Button>



      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>

          <ModalHeader>{!editMode ? 'Sukurti duris' : 'Redaguoti duris'}</ModalHeader>

          <ModalCloseButton />
          <ModalBody m={'1rem'}>
            {loading ?
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='green.500'
                size='xl'
              />
              :
              <form onSubmit={!editMode ? handleSubmit(onSubmit) : handleSubmit(onEdit)}>
  <FormControl maxW={'30rem'}>
    
    {/* Pavadinimas */}
    <FormLabel>Pavadinimas</FormLabel>
    <Input 
      autoComplete="off"
      mb="1rem"
      id="DoorName"
      {...register("DoorName", { required: true })}
      name="DoorName"
      type="text"
    />

    {/* Door Serial */}
    <FormLabel>Įrenginio serijinis numeris</FormLabel>
    <Input
      autoComplete="off"
      mb="1rem"
      id="DoorSerial"
      {...register("DoorSerial")}
      name="DoorSerial"
      placeholder="Pvz.: SN23-8472 arba tuščia jei IP durys"
      type="text"
    />

    {/* Is Main Door */}
      <FormLabel htmlFor="IsMainDoor">Pagrindinės durys</FormLabel>
      <Switch
        id="IsMainDoor"
        {...register("IsMainDoor")}
      >
        Pagrindinės
      </Switch>


    {/* Info blokas */}
    <Text bg="orange.500" p="1rem" color="#fff" fontSize="0.8rem" borderRadius="md">
      Po durų sukūrimo ar redagavimo reikia perkrauti serverį,
      kitaip pakeitimai neatsivaizduos.
    </Text>

    {/* Submit */}
    <Button
      mt="1rem"
      width="100%"
      colorScheme="green"
      isLoading={isSubmitting}
      type="submit"
    >
      {!editMode ? 'Sukurti duris' : 'Redaguoti duris'}
    </Button>
  </FormControl>
</form>


            }




          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertDialog
        isCentered
        isOpen={isOpenAlert}
        leastDestructiveRef={cancelRef}
        onClose={onCloseAlert}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              [{deleteDoor}] Ištrinti duris?
            </AlertDialogHeader>

            <AlertDialogBody>
              Ar jūs įsitikinę? Šių duru susigrąžinti nebegalėsite. Visi susije laikai su durimis taip pat bus ištrinti.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseAlert}>
                Atšaukti
              </Button>
              <Button colorScheme='red' onClick={() => handleDelete(deleteDoor)} ml={3}>
                Ištrinti
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>


      <>
        <TableContainer height={'70vh'} display={'block'} overflowY={'scroll'}>
          <Table variant='simple'>
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Pavadinimas</Th>
                <Th>Durų IP</Th>
                <Th>Pagrindinės durys</Th>
                <Th textAlign={'center'}>Veiksmai</Th>
              </Tr>
            </Thead>
            <Tbody>
              {allDoors.map((userRow, index) => {
console.log(userRow);
                return (
                  <Tr key={index}>
                    <Td>{userRow.DoorID}</Td>
                    <Td>{userRow.DoorName}</Td>
                    <Td>
                      {userRow.DoorSerial === null || userRow.DoorSerial === "" || userRow.DoorSerial === "null"
                        ? <Badge colorScheme="gray">Įrenginio IP</Badge>
                        : userRow.DoorSerial}
                    </Td>
                    <Td>
                      {userRow.isMainDoor === 1 ? (
                        <Badge colorScheme="green">PAGRINDINĖS</Badge>
                      ) : (
                        <Badge colorScheme="gray">PAPILDOMOS</Badge>
                      )}
                    </Td>

                    <Td textAlign={'center'}><Menu>
                      <MenuButton
                        as={IconButton}
                        aria-label='Options'
                        icon={<HamburgerIcon />}
                        variant='outline'
                      />
                      <MenuList>
                        <MenuItem onClick={() => { setEditDoor(userRow); setEditMode(true); onOpen(); }} icon={<EditIcon />}>
                          Redaguoti
                        </MenuItem>
                        <MenuItem onClick={() => { setDeleteDoor(userRow.DoorID); onOpenAlert() }} color={'red.500'} icon={<DeleteIcon />}>
                          Ištrinti
                        </MenuItem>
                      </MenuList>
                    </Menu></Td>
                  </Tr>
                )
              })}

            </Tbody>
          </Table>
        </TableContainer>



      </>



    </>
  )
}

export default DoorAdminPage